import React, { useEffect, useState, useCallback } from "react";
import { api, API, CHF } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

export default function ChiffresTab() {
  const now = new Date();
  const [month, setMonth] = useState(now.getMonth() + 1);
  const [year, setYear] = useState(now.getFullYear());
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    api.get("/accounting", { params: { month, year } }).then((r) => setData(r.data));
  }, [month, year]);
  useEffect(() => { load(); }, [load]);

  const downloadPdf = async () => {
    const token = localStorage.getItem("ata_admin_token");
    const res = await fetch(`${API}/accounting/pdf?month=${month}&year=${year}`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `rapport_${year}_${String(month).padStart(2, "0")}.pdf`;
    a.click(); URL.revokeObjectURL(url);
  };

  const years = [now.getFullYear(), now.getFullYear() - 1];

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
        <h2 className="font-display text-2xl font-bold">Comptabilité</h2>
        <div className="flex gap-2">
          <select value={month} onChange={(e) => setMonth(parseInt(e.target.value))} className="rounded-none bg-neutral-800 border border-white/20 px-3 py-2 text-sm" data-testid="month-select">
            {MONTHS.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
          </select>
          <select value={year} onChange={(e) => setYear(parseInt(e.target.value))} className="rounded-none bg-neutral-800 border border-white/20 px-3 py-2 text-sm" data-testid="year-select">
            {years.map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
          <Button onClick={downloadPdf} className="rounded-none bg-brand-red hover:bg-brand-red/90" data-testid="download-pdf-btn"><Download className="w-4 h-4 mr-2" />PDF</Button>
        </div>
      </div>

      {data && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            {[["CA TTC", CHF(data.ca_ttc)], ["CA HT", CHF(data.ca_ht)], ["TVA", CHF(data.tva)], ["Commandes", data.count]].map(([l, v], i) => (
              <div key={i} className="border border-white/15 p-4" data-testid={`kpi-${i}`}>
                <p className="text-xs uppercase tracking-widest text-white/50">{l}</p>
                <p className="font-display text-2xl font-extrabold mt-1">{v}</p>
              </div>
            ))}
          </div>

          <h3 className="text-sm uppercase tracking-widest text-white/50 mb-2">Détail TVA</h3>
          <table className="w-full text-sm mb-6 border border-white/15">
            <thead className="bg-brand-red text-white"><tr><th className="p-2 text-left">Taux</th><th className="p-2 text-right">CA HT</th><th className="p-2 text-right">TVA</th><th className="p-2 text-right">CA TTC</th><th className="p-2 text-right">Nb</th></tr></thead>
            <tbody>
              {data.vat_breakdown.map((b, i) => (
                <tr key={i} className="border-t border-white/10"><td className="p-2">{b.rate}%</td><td className="p-2 text-right">{CHF(b.ht)}</td><td className="p-2 text-right">{CHF(b.tva)}</td><td className="p-2 text-right">{CHF(b.ttc)}</td><td className="p-2 text-right">{b.count}</td></tr>
              ))}
              {data.vat_breakdown.length === 0 && <tr><td colSpan={5} className="p-3 text-center text-white/40">Aucune donnée</td></tr>}
            </tbody>
          </table>

          <h3 className="text-sm uppercase tracking-widest text-white/50 mb-2">Produits vendus</h3>
          <table className="w-full text-sm border border-white/15">
            <thead className="bg-neutral-800"><tr><th className="p-2 text-left">Produit</th><th className="p-2 text-right">Qté</th><th className="p-2 text-right">CA</th></tr></thead>
            <tbody>
              {data.products.map((p, i) => (
                <tr key={i} className="border-t border-white/10"><td className="p-2">{p.name}</td><td className="p-2 text-right">{p.qty}</td><td className="p-2 text-right">{CHF(p.revenue)}</td></tr>
              ))}
              {data.products.length === 0 && <tr><td colSpan={3} className="p-3 text-center text-white/40">Aucune vente</td></tr>}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
